/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  FwBuild,
  FirmwareData,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetLatestFirmwareDataInput {
  thingDef: string;
  build: FwBuild;
  compatibleWith?: string;
}
const build = (_query: DocumentNode, input: GetLatestFirmwareDataInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.thingDef !== undefined ? `$thingDef: String = ${JSON.stringify(input.thingDef).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.build !== undefined ? `$build: FwBuild = ${input.build}, ` : '' ) + ``+
    ( input.compatibleWith !== undefined ? `$compatibleWith: String = ${JSON.stringify(input.compatibleWith).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getLatestFirmwareData(
      ${ input.thingDef !== undefined ? 'thingDef: $thingDef,' : '' } 
      ${ input.build !== undefined ? 'build: $build,' : '' } 
      ${ input.compatibleWith !== undefined ? 'compatibleWith: $compatibleWith,' : '' }
    ){
      ...firmwaredata
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetLatestFirmwareDataQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment firmwaredata on FirmwareData { ... }
   */
  async execute(_query: DocumentNode, input: GetLatestFirmwareDataInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getLatestFirmwareData: Partial<FirmwareData> }>({ query: build(_query, input), fetchPolicy });
  }
}
